import { DropDownCell } from "./Default/DropDownCell";
import { CustomGridCellProps } from "./CustomGridCellProps";
import { GridRowClickProps } from "../GridRowClickProps";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

export function RC2DropdownCell({
  editable,
  isReadOnly,
  ...props
}: CustomGridCellProps & GridRowClickProps & ReadOnlyProps) {
  return (
    <DropDownCell
      {...props}
      localizedData={rc2LocalizedData}
      editable={editable ?? true}
      isReadOnly={isReadOnly}
    />
  );
}

const rc2LocalizedData = [
  { text: "Yes", value: true },
  { text: "No", value: false },
];
